<template>
  <div>
    <b-form>
      <b-row>
        <b-col md="12">
          <b-form-group
            label="State"
            label-for="await-type"
          >
            <v-select
              v-model="activeProcess"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="activeProcessesOptions"
              :reduce="val => val.value"
              :clearable="false"
              input-id="activeProcesses"
            />
          </b-form-group>
        </b-col>
        <b-col
          v-if="activeProcess > 0"
          cols="12"
        >
          <b-button
            variant="primary"
            type="submit"
            class="addStateBtn"
            @click.prevent="submitStateForm"
          >
            {{ $t('DEBTIA_SUBMIT') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from '@axios'
import {
  BFormGroup,
  // BButton,
  BForm,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    // BCardCode,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    vSelect,
    BButton,
  },
  props: {
    conditionObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activeProcess: 0,
      activeProcessesOptions: [],
    }
  },
  created() {
    this.getProcesses()
  },
  methods: {
    getProcesses() {
      const url = '/process/get-processes-dropdown?type=primary'
      axios.get(url).then(response => {
        if (response.status) {
          this.activeProcessesOptions = response.data.data.processes
        }
      })
    },
    submitStateForm() {
      const url = '/process/module/add'
      const processID = this.$route.params.id
      const dataObj = {
        process_id: Number(processID),
        module_id: 5,
        module_order: 1,
        new_process_id: this.activeProcess,
      }
      if (this.conditionObject.moduleID > 0) {
        dataObj.depends_on = this.conditionObject.moduleID
        dataObj.condition = this.conditionObject.type
      }
      axios.post(url, dataObj).then(response => {
        if (response.status === 200) {
          this.activeProcess = 0
          const returnObj = {
            parentID: this.conditionObject.parentID,
            depend: dataObj.depends_on,
          }
          returnObj.type = this.conditionObject.type ? this.conditionObject.type : 0
          this.$emit('closeChangeStateModal', returnObj)
        }
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  .addStateBtn {
    width: 100%;
  }
</style>
